import { shopConstants } from '../constants';

const initialState = {
    detail: {},
    config: {},
    isShopPublic: false,
    status: "",
    error: {}
};

export function shop(state = initialState, action) {
    switch (action.type) {
        case shopConstants.GET_PUBLIC_SHOP_REQUEST:
            return {
              ...state,
              status: "GET_PUBLIC_SHOP_REQUEST"
            }
        case shopConstants.GET_PUBLIC_SHOP_SUCCESS:
          return {
            ...state,
            detail: action.payload,
            isShopPublic: true,
            status: "GET_PUBLIC_SHOP_SUCCESS"
          }
        case shopConstants.GET_PUBLIC_SHOP_ERROR:
          return {
            ...state,
            detail: {},
            isShopPublic: false,
            error: action.payload,
            status: "GET_PUBLIC_SHOP_ERROR"
          }
        case shopConstants.GET_PUBLIC_SHOP_CONFIG_REQUEST:
            return {
              ...state,
              status: "GET_PUBLIC_SHOP_CONFIG_REQUEST"
            }
        case shopConstants.GET_PUBLIC_SHOP_CONFIG_SUCCESS:
          return {
            ...state,
            config: action.payload,
            status: "GET_PUBLIC_SHOP_CONFIG_SUCCESS"
          }
        case shopConstants.GET_PUBLIC_SHOP_CONFIG_ERROR:
          return {
            ...state,
            config: {},
            error: action.payload,
            status: "GET_PUBLIC_SHOP_CONFIG_ERROR"
          }
        case shopConstants.IS_SHOP_PUBLIC_REQUEST:
            return {
              ...state,
              status: "IS_SHOP_PUBLIC_REQUEST"
            }
        case shopConstants.IS_SHOP_PUBLIC_SUCCESS:
          return {
            ...state,
            isShopPublic: action.payload,
            status: "IS_SHOP_PUBLIC_SUCCESS"
          }
        case shopConstants.IS_SHOP_PUBLIC_ERROR:
          return {
            ...state,
            detail: {},
            isShopPublic: false,
            error: action.payload,
            status: "IS_SHOP_PUBLIC_ERROR"
          }
        default:
            return state
    }
};